import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';

const ITEM_HEIGHT = 48;

export default function PreEx6TableActions({ row, action }) {
	const [anchorEl, setAnchorEl] = React.useState(null);
	const open = Boolean(anchorEl);

	const handleClick = event => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<div>
			<IconButton title="Actions" aria-label="actions" aria-controls="actions-menu" aria-haspopup="true" onClick={handleClick} style={{ padding: '5px 15px' }}>
				<MoreHorizIcon />
			</IconButton>
			<Menu
				id="actions-menu"
				anchorEl={anchorEl}
				keepMounted
				open={open}
				onClose={handleClose}
				PaperProps={{
					style: {
						maxHeight: ITEM_HEIGHT * 4.5,
						width: '25.5ch'
					}
				}}
			>
				<MenuItem key={'view_pdf'} id="view_pdf" onClick={e => action(e, row)}>
					View PDF
				</MenuItem>
				<MenuItem key={'view_tAndC'} id="view_tAndC" onClick={e => action(e, row)}>
					View Terms and Conditions
				</MenuItem>
				<MenuItem key={'export_excel'} id="export_excel" onClick={e => action(e, row)}>
					Export To Excel
				</MenuItem>
				<MenuItem key={'validate_contract'} id="validate_contract" onClick={e => action(e, row)}>
					Check Contract
				</MenuItem>
			</Menu>
		</div>
	);
}
